import { getSpaceKey, getSpacesKey } from '../../utils/keys';
// get all active spaces query
export const getSpacesQueryById = spaceId => ({
    active: true,
    predicate: query => {
        var _a, _b;
        const [main, args] = (query === null || query === void 0 ? void 0 : query.queryKey) || [];
        if ((((_b = (_a = args) === null || _a === void 0 ? void 0 : _a.variables) === null || _b === void 0 ? void 0 : _b.spaceId) !== spaceId &&
            main === getSpaceKey()[0]) ||
            main === getSpacesKey()[0]) {
            return true;
        }
        return false;
    },
});
//# sourceMappingURL=filters.js.map